import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchTerms = async (subscriberGroupId) => {
    const res = await axios.get(`${API_BASE_URL}/subscriber-group-terms/${subscriberGroupId}`);
    return res?.data?.data?.terms ?? "";
};

export const useTerms = (subscriberGroupId) => {
    const { data, isLoading } = useQuery({
        queryKey: ["terms", subscriberGroupId],
        queryFn: () => fetchTerms(subscriberGroupId),
        enabled: !!subscriberGroupId,
        staleTime: Infinity,
    });

    return {
        terms: data ?? "",
        isLoading,
    };
};
